import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { kailuaKonaConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={kailuaKonaConfig} />;
}